// extracted by mini-css-extract-plugin
module.exports = {"category":"ChannelLabel__category___36aq6"};